module.exports = __webpack_public_path__ + "static/covoloIn-504e77a9c0768fa3af510ce58457e6c1.jpg";